import { Dialog } from '@elementary/common-ui/components';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/alert-info.svg';
import { Typography } from '@mui/material';
import { fontSize } from '@elementary/common-ui/style/utils';

type EditConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
};

const EditConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  message,
}: EditConfirmationDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    onConfirmButtonClick={onConfirm}
    title="Confirm re-authentication"
    titleIcon={<InfoIcon />}
    message={message}
    secondaryMessage={
      <Typography sx={{ fontSize: fontSize('sm') }}>
        This action is irreversible.
      </Typography>
    }
    confirmText="Overwrite"
    variant="error"
    customWidth={540}
  />
);

export default EditConfirmationDialog;
